import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VForm } from 'vuetify/lib/components/VForm';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      !_vm.tplToWork ? _c("p", [_vm._v("Template not found!")]) : _vm._e(),
      _vm.tplToWork && _vm.defaultFields
        ? _c(
            VForm,
            {
              ref: "form",
              staticClass: "form pa-2",
              attrs: { "lazy-validation": "" },
              model: {
                value: _vm.valid,
                callback: function ($$v) {
                  _vm.valid = $$v
                },
                expression: "valid",
              },
            },
            [
              _c(
                VRow,
                { attrs: { dense: "" } },
                [
                  _c(
                    VCol,
                    { staticClass: "col-md-2 col-sm-4 col-4" },
                    [
                      _c(VSubheader, { staticClass: "font-weight-bold" }, [
                        _vm._v(
                          _vm._s(_vm.$t("my_tasks.modals.table_requested")) +
                            ": "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { staticClass: "col-md-4 col-sm-8 col-8" },
                    [
                      _c(VTextField, {
                        attrs: {
                          small: "",
                          dense: "",
                          filled: "",
                          value: _vm._f("joinTableReference")(
                            _vm.tplToWork.tableReference
                          ),
                          readonly: "",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { staticClass: "col-md-2 col-sm-4 col-4" },
                    [
                      _c(VSubheader, { staticClass: "font-weight-bold" }, [
                        _vm._v(
                          _vm._s(_vm.$t("my_tasks.modals.request_by")) + ":"
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { staticClass: "col-md-4 col-sm-8 col-8" },
                    [
                      _c(VTextField, {
                        attrs: {
                          small: "",
                          dense: "",
                          filled: "",
                          value: _vm.toCreateView.applicant,
                          readonly: "",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VRow,
                { attrs: { dense: "" } },
                [
                  _c(
                    VCol,
                    { staticClass: "col-md-2 col-sm-4 col-4" },
                    [
                      _c(VSubheader, { staticClass: "font-weight-bold" }, [
                        _vm._v(_vm._s(_vm.$t("my_tasks.modals.start_date"))),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { staticClass: "col-md-4 col-sm-8 col-8" },
                    [
                      _c(VTextField, {
                        attrs: {
                          dense: "",
                          filled: "",
                          size: "sm",
                          type: "text",
                          readonly: "",
                        },
                        model: {
                          value: _vm.tplToWork.created,
                          callback: function ($$v) {
                            _vm.$set(_vm.tplToWork, "created", $$v)
                          },
                          expression: "tplToWork.created",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { staticClass: "col-md-2 col-sm-4 col-4" },
                    [
                      _c(VSubheader, { staticClass: "font-weight-bold" }, [
                        _vm._v(_vm._s(_vm.$t("my_tasks.modals.request_until"))),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { staticClass: "col-md-4 col-sm-8 col-8" },
                    [
                      _c(
                        VMenu,
                        {
                          attrs: {
                            transition: "scale-transition",
                            "max-width": "290px",
                            "min-width": "290px",
                            "close-on-content-click": false,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function (ref) {
                                  var on = ref.on
                                  var attrs = ref.attrs
                                  return [
                                    _c(
                                      VTextField,
                                      _vm._g(
                                        _vm._b(
                                          {
                                            attrs: {
                                              "append-icon": "event",
                                              readonly: "",
                                              dense: "",
                                              outlined: "",
                                              "hide-details": "auto",
                                              placeholder: "YYYY-MM-DD",
                                            },
                                            on: { "click:append": on.click },
                                            model: {
                                              value: _vm.toCreateView.endDate,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.toCreateView,
                                                  "endDate",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "toCreateView.endDate",
                                            },
                                          },
                                          "v-text-field",
                                          attrs,
                                          false
                                        ),
                                        on
                                      )
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2013332926
                          ),
                          model: {
                            value: _vm.menu_calendar,
                            callback: function ($$v) {
                              _vm.menu_calendar = $$v
                            },
                            expression: "menu_calendar",
                          },
                        },
                        [
                          _c(VDatePicker, {
                            attrs: { scrollabel: "" },
                            on: {
                              input: function ($event) {
                                _vm.menu_calendar = false
                              },
                            },
                            model: {
                              value: _vm.toCreateView.endDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.toCreateView, "endDate", $$v)
                              },
                              expression: "toCreateView.endDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.toCreateView.isExternalUser
                ? [
                    _c(
                      VRow,
                      { attrs: { dense: "" } },
                      [
                        _c(
                          VCol,
                          { staticClass: "col-md-2 col-sm-4 col-4" },
                          [
                            _c(
                              VSubheader,
                              { staticClass: "font-weight-bold" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("my_tasks.modals.external_user")
                                  )
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          VCol,
                          { staticClass: "col-md-4 col-sm-8 col-8" },
                          [
                            _c(VTextField, {
                              attrs: {
                                small: "",
                                dense: "",
                                filled: "",
                                value: _vm.toCreateView.isServiceAccount
                                  ? "Service Account"
                                  : "User",
                                readonly: "",
                              },
                            }),
                          ],
                          1
                        ),
                        (_vm.toCreateView.service_account_type ==
                          "PRODUCTIVIZE" ||
                          _vm.toCreateView.service_account_type ==
                            "ATTRIBUTE") &&
                        _vm.toCreateView.sandbox
                          ? [
                              _c(
                                VCol,
                                { staticClass: "col-md-2 col-sm-4 col-4" },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [_vm._v("Use Case")]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { staticClass: "col-md-4 col-sm-8 col-8" },
                                [
                                  _c(VTextField, {
                                    attrs: {
                                      small: "",
                                      dense: "",
                                      filled: "",
                                      value: _vm.toCreateView.sandbox.name,
                                      readonly: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                    _c(
                      VRow,
                      { attrs: { dense: "" } },
                      [
                        _c(
                          VCol,
                          { staticClass: "col-md-2 col-sm-4 col-4" },
                          [
                            _c(
                              VSubheader,
                              { staticClass: "font-weight-bold" },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("my_tasks.modals.client_email"))
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          VCol,
                          { staticClass: "col-md-10 col-sm-8 col-8" },
                          [
                            _c(VTextField, {
                              attrs: {
                                small: "",
                                dense: "",
                                filled: "",
                                value: _vm.toCreateView.benefited,
                                readonly: "",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      VRow,
                      { attrs: { dense: "" } },
                      [
                        _c(
                          VCol,
                          { staticClass: "col-md-2 col-sm-4 col-4" },
                          [
                            _c(
                              VSubheader,
                              { staticClass: "font-weight-bold" },
                              [_vm._v("Business case")]
                            ),
                          ],
                          1
                        ),
                        _c(
                          VCol,
                          { staticClass: "col-md-10 col-sm-8 col-8" },
                          [
                            _c(VTextField, {
                              attrs: {
                                small: "",
                                dense: "",
                                filled: "",
                                value: _vm.toCreateView.business_case,
                                readonly: "",
                                "hide-details": "auto",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _vm.invalidDate
                ? _c(
                    VAlert,
                    {
                      staticClass: "mt-2",
                      attrs: {
                        border: "bottom",
                        "colored-border": "",
                        type: "error",
                        elevation: "2",
                      },
                    },
                    [_vm._v("The Final Date must be higher than Start Date")]
                  )
                : _vm._e(),
              _c("list-table-metadata-cols-component", {
                attrs: {
                  columnFields: _vm.columnFields,
                  defaultFields: _vm.defaultFields,
                  isChangeRequest: _vm.TYPE_CHANGE_METADA.VIEWER_ONLY,
                  showTitle: false,
                  isRequestView: true,
                  isOwnerApproval: false,
                },
              }),
              _c(
                VRow,
                { staticClass: "mt-2", attrs: { dense: "" } },
                [
                  _c(
                    VCol,
                    { attrs: { cols: "3", lg: "2" } },
                    [
                      _c(VSubheader, { staticClass: "font-weight-bold" }, [
                        _vm._v(
                          _vm._s(_vm.$t("my_tasks.modals.request_reason"))
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "9" } },
                    [
                      _c(VTextarea, {
                        attrs: {
                          filled: "",
                          dense: "",
                          size: "sm",
                          rows: "3",
                          "max-rows": "6",
                          type: "text",
                          required: "",
                          placeholder: "Message..123.",
                          readonly: "",
                        },
                        model: {
                          value: _vm.tplToWork.commentary,
                          callback: function ($$v) {
                            _vm.$set(_vm.tplToWork, "commentary", $$v)
                          },
                          expression: "tplToWork.commentary",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VRow,
                { attrs: { dense: "" } },
                [
                  _c(
                    VCol,
                    { attrs: { cols: "3", lg: "2" } },
                    [
                      _c(VSubheader, { staticClass: "font-weight-bold" }, [
                        _vm._v(_vm._s(_vm.$t("my_tasks.modals.response"))),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "9" } },
                    [
                      _c(VTextarea, {
                        attrs: {
                          outlined: !_vm.isOnlyView,
                          readonly: _vm.isOnlyView,
                          disabled: _vm.isOnlyView,
                          filled: _vm.isOnlyView,
                          dense: "",
                          rows: "3",
                          "max-rows": "6",
                          rules: [
                            function (v) {
                              return !!v || _vm.translate("reglas.field")
                            },
                          ],
                          type: "text",
                          required: "",
                          placeholder: "...",
                        },
                        model: {
                          value: _vm.toCreateView.response,
                          callback: function ($$v) {
                            _vm.$set(_vm.toCreateView, "response", $$v)
                          },
                          expression: "toCreateView.response",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          )
        : _c("b", [_vm._v("Error at load data!")]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }